import React, { useState, useEffect, useRef } from 'react';
import useGeneralStore from '../../store/general';
import customHeaders, { getSpace } from '../../common/headers';
import { useShallow } from 'zustand/react/shallow';
import { useDataTable } from '../../common/hooks';
import { TableBox, DropDownSelector, ButtonClose, Checkbox, ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { fetchNotificationsError } from '../../common/filtersFunc';
import { RequestController } from '../../common/filtersFunc';
import { StepItem } from '../../components/StepItem/StepItem';
import "./NotificationsError.scss";
import { useResponseHandler } from '../../common/auth';
import { ModalComponent } from '../../components/Modal/ModalComponent/ModalComponent';

const NotificationsError = ({ }) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleTableResponse, handleRequestError } = useResponseHandler();
    // Реф для хранения контроллера запросов
    const requestControllerRef = useRef(new RequestController());
    const refContainer = useRef()
    const {
        currentFilterService,
        setIsModalNotificationsError,
        setCurrentFilterService
    } = useGeneralStore(
        useShallow((state) => ({
            currentFilterService: state.currentFilterService,
            setIsModalNotificationsError: state.setIsModalNotificationsError,
            setCurrentFilterService: state.setCurrentFilterService
        }))
    );

    // Таблица
    const [isTableRequest, setIsTableRequest] = useState(false);
    const paginatorRef = useRef()
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    )
    const { setLoading } = setTableFuncs;
    const { loading, sort, filters } = tableProps;

    // Фильтры
    const [servicePage, setServicePage] = useState(1);
    const [serviceQuery, setServiceQuery] = useState('');
    const [serviceData, setServiceData] = useState([]);
    const [selectedService, setSelectedService] = useState(null);

    const [isOnlyRead, setIsOnlyRead] = useState(false)
    const [selectedItems, setSelectedItems] = useState([]);
    const [resetSelected, setResetSelected] = useState(false)

    // Фильтр
    const filtersService = () => {
        const controller = requestControllerRef.current.createController('brand');

        fetchNotificationsError({
            controller,
            selectedSpace: selectedSpace?.value,
            page: servicePage,
            searchParam: serviceQuery,
            set: (e) => setServiceData(e),
        })?.finally(() => {
            requestControllerRef.current.removeController('brand');
        })
    }

    useEffect(() => {
        filtersService()
    }, [servicePage, serviceQuery]);

    useEffect(() => {
        if (currentFilterService && serviceData?.length) {
            const currentFilter = serviceData?.filter((item) => item.value === currentFilterService)?.[0]
            setSelectedService(currentFilter || null)
            setCurrentFilterService(null)
        }
    }, [currentFilterService, serviceData]);

    // Таблица
    const fetchTableData = (params, abortController = new AbortController()) => {
        if (!selectedService?.value) return

        let sort;
        let filtersParam = [];

        if (params) {
            [sort, filtersParam] = params;
        }

        setLoading(true);

        let url = `https://apps1.ecomru.ru:4455/error-notifications/table${sort?.length > 0
            ? '?order_param=' + sort[0] + '&order_direction=' + sort[1]
            : ''}`;

        const body = JSON.stringify({
            page: paginatorRef.current?.page,
            limit: paginatorRef.current?.limit,
            filters: Array.isArray(filtersParam) ? filtersParam : filters,
            service_id: selectedService?.value,
            only_not_read: isOnlyRead
        });

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => setTable(json))
            .catch(handleRequestError)
            .finally(() => {
                if (!abortController.signal.aborted) {
                    setLoading(false);
                }
            });
    };

    // Прочитать все
    const fetchReadAll = (params, abortController = new AbortController()) => {
        if (!selectedService?.value) return

        let url = `https://apps1.ecomru.ru:4455/error-notifications/read-all`;

        const body = JSON.stringify({
            service_id: selectedService?.value,
        });

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => setIsTableRequest(!isTableRequest))
            .catch(handleRequestError)
    };

    // Прочитать выбранные
    const fetchReadById = (currentScenario = undefined) => {
        let url = 'https://apps1.ecomru.ru:4455/error-notifications/read-by-ids'

        const body = JSON.stringify({
            ids: currentScenario || selectedItems.map((el) => el?.['ID сценария'])
        });

        fetch(url, { body, method: 'POST', headers })
            .then(handleTableResponse)
            .then((json) => {
                if (!currentScenario) {
                    setSelectedItems([])
                    setResetSelected(!resetSelected)
                }
                setIsTableRequest(!isTableRequest)
            })
            .catch(handleRequestError)
    };

    useEffect(() => {
        const abortController = new AbortController();
        fetchTableData([], abortController);
        return () => abortController.abort();
    }, [isTableRequest]);

    useEffect(() => {
        if (selectedService?.value) {
            paginatorRef.current.reset()
            paginatorRef.current.setTotal(0)
            setIsTableRequest(!isTableRequest)
        }
    }, [selectedService, isOnlyRead]);

    const handleCheck = (data) => {
        setSelectedItems(data);
    };

    const onAction = (e) => {
        const currentScenario = [e?.['ID сценария']]
        fetchReadById(currentScenario);
    };

    return (
        <ModalComponent
            title='Уведомлений об ошибках'
            onClose={() => setIsModalNotificationsError(false)}
            child={
            <div className='modal-notifications-error'>
                <DropDownSelector
                    options_prop={serviceData}
                    state={selectedService}
                    setState={setSelectedService}
                    placeholder="Сервис"
                    fetchCallback={setServicePage}
                    setInputChange={setServiceQuery}
                    isClearable={false}
                />

                {!selectedService?.value && <StepItem
                    title='Выберите сервис, чтобы загрузить таблицу'
                />}

                <div
                    className='modal-notifications-error__content-table'
                    ref={refContainer}>
                    <TableBox
                        {...tableProps}
                        refContainer={refContainer}
                        paginator={true}
                        ref={paginatorRef}
                        fetchCallback={fetchTableData}
                        onCheck={handleCheck}
                        onUncheckAllDependence={[resetSelected]}
                        onAction={onAction}
                        child={
                            <>
                                <ButtonBasic
                                    width='auto'
                                    blue
                                    size='32px'
                                    onClick={fetchReadById}
                                    text='Отметить выбранные как прочитанные'
                                    disabled={!selectedItems?.length}
                                />

                                <ButtonBasic
                                    width='auto'
                                    whiteBlue
                                    size='32px'
                                    onClick={fetchReadAll}
                                    text='Отметить все как прочитанные'
                                    disabled={!selectedService?.value}
                                />

                                <Checkbox
                                    value={isOnlyRead}
                                    onChange={(e) => setIsOnlyRead(!isOnlyRead)}
                                >Не прочитанные</Checkbox>
                            </>
                        }
                    />
                </div>

            </div>}
        />
    );
};

export { NotificationsError };